import * as AssetsAPI from 'api/assets';
import { IMAGE_RATIO } from 'defs/assets';
import { call, put, select } from 'redux-saga/effects';
import { actionCreators as assetsAC, getAsset } from 'store/assets';

export function* loadAsset(action: ReturnType<typeof assetsAC.doLoadAsset>) {
	const { path, ratio = IMAGE_RATIO.R1_1 } = action;
	const storedAsset = yield select(getAsset, path, ratio as any);

	if (storedAsset) {
		return;
	}

	const asset: any = yield call(AssetsAPI.loadAsset as any, path, ratio);
	if (asset) {
		yield put(assetsAC.doLoadAssetSuccess(path, asset, ratio as any));
	}
}
